import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function EstimationStep4({ formData, errors, updateFormData, onSubmit, onBack, isSubmitting }) {
  return (
    <div data-testid="estimation-step-4">
      <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-6">
        Recevez votre estimation
      </h2>

      <div className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="first_name">Prénom *</Label>
            <Input
              id="first_name"
              value={formData.first_name}
              onChange={(e) => updateFormData('first_name', e.target.value)}
              placeholder="Jean"
              data-testid="estimation-first-name"
            />
            {errors.first_name && <p className="text-sm text-red-500 mt-1">{errors.first_name}</p>}
          </div>
          <div>
            <Label htmlFor="last_name">Nom *</Label>
            <Input
              id="last_name"
              value={formData.last_name}
              onChange={(e) => updateFormData('last_name', e.target.value)}
              placeholder="Dupont"
              data-testid="estimation-last-name"
            />
            {errors.last_name && <p className="text-sm text-red-500 mt-1">{errors.last_name}</p>}
          </div>
        </div>

        <div>
          <Label htmlFor="email">Email *</Label>
          <Input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => updateFormData('email', e.target.value)}
            placeholder="votre@email.com"
            data-testid="estimation-email"
          />
          {errors.email && <p className="text-sm text-red-500 mt-1">{errors.email}</p>}
        </div>

        <div>
          <Label htmlFor="phone">Téléphone *</Label>
          <Input
            id="phone"
            type="tel"
            value={formData.phone}
            onChange={(e) => updateFormData('phone', e.target.value)}
            placeholder="Votre numéro"
            data-testid="estimation-phone"
          />
          {errors.phone && <p className="text-sm text-red-500 mt-1">{errors.phone}</p>}
        </div>

        <p className="text-xs text-[#8B8B8B] mt-4">
          ✓ Vos données restent confidentielles<br />
          ✓ Aucune obligation<br />
          ✓ Réponse rapide
        </p>
      </div>

      <div className="flex gap-4 mt-8">
        <Button
          onClick={onBack}
          variant="outline"
          className="flex-1"
          data-testid="estimation-back-4"
          disabled={isSubmitting}
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Retour
        </Button>
        <Button
          onClick={onSubmit}
          className="flex-1 bg-[#8A9474] hover:bg-[#7A8464] text-white"
          data-testid="estimation-submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Envoi...' : 'Recevoir mon estimation'}
        </Button>
      </div>
    </div>
  );
}
